/*
  OMOTOR cart fix
  ---------------------------------------------------------------------------
  1) Bullet-proof "remove item".
     The trash button is handled here with a delegated capture-phase listener on
     document, so it keeps working no matter what happens inside cart.js (missing
     DOM nodes, a custom element that failed to upgrade, a re-rendered drawer).
     The request goes straight to /cart/change with the sections we need back, so
     one round trip both deletes the line and repaints the drawer.
     If anything at all goes wrong we fall back to the theme's own updateQuantity,
     and if that is unavailable too we send the shopper to /cart.

  2) Always-visible scroll indicator for the drawer item list.
     iOS Safari ignores ::-webkit-scrollbar completely, so the bar has to be drawn
     by hand. A fixed-position track is parked on document.body (it therefore
     survives every drawer re-render) and follows the item list's bounding box.

  3) Trust strip above checkout, using the SAME outlined icons as the homepage
     trust bar (sections/omotor-trustbar.liquid): returns arrow / warranty shield
     / shipping truck, orange chips on white. This replaces the old emoji-in-a-
     green-box strip that omotor-cart-skin.css drew with .drawer__footer::before
     (that rule is neutralised below rather than edited, so the skin file stays
     byte-identical to production).

  Loaded from snippets/opro-fonts.liquid. Delete the file + that one script tag
  to revert everything in here.
*/
(function () {
  if (window.__omotorCartFix) return;
  window.__omotorCartFix = 1;

  var CHANGE_URL = (window.routes && window.routes.cart_change_url) || '/cart/change';
  var CART_URL = (window.routes && window.routes.cart_url) || '/cart';

  /* ------------------------------------------------------------------ styles */
  var css =
    /* keep the trash button on top and give it a real 44px tap target */
    '#CartDrawer cart-remove-button,.cart-items cart-remove-button{position:relative;z-index:5;flex:0 0 auto;pointer-events:auto !important}' +
    '#CartDrawer cart-remove-button .cart-remove-button,#CartDrawer .cart-remove-button{display:flex !important;align-items:center;justify-content:center;min-width:4.4rem;min-height:4.4rem;padding:0 !important;pointer-events:auto !important;touch-action:manipulation;-webkit-tap-highlight-color:transparent}' +
    '#CartDrawer .cart-item__quantity-wrapper{position:relative;z-index:5}' +
    '#CartDrawer .cart-item.omg-removing{opacity:.4;transition:opacity .15s ease}' +
    /* hide the native bar — ours replaces it on every platform */
    '#CartDrawer cart-drawer-items{scrollbar-width:none !important}' +
    '#CartDrawer cart-drawer-items::-webkit-scrollbar{width:0 !important;height:0 !important}' +
    /* the hand-drawn indicator */
    '.omg-sb{position:fixed;width:4px;border-radius:4px;background:rgba(20,22,26,.08);z-index:10000;pointer-events:none;opacity:0;transition:opacity .2s ease}' +
    '.omg-sb.is-on{opacity:1}' +
    '.omg-sb-thumb{position:absolute;left:0;top:0;width:100%;border-radius:4px;background:rgba(20,22,26,.34)}' +
    /* retire the old emoji strip drawn by omotor-cart-skin.css */
    '#CartDrawer .drawer__footer::before{content:none !important;display:none !important}' +
    /* new trust strip — same icon language as the homepage trust bar, laid out
       inline so it costs no more drawer height than the old one-line strip did */
    '#CartDrawer .omg-trust{display:grid;grid-template-columns:repeat(3,1fr);gap:.2rem;background:#fff;border:1px solid #e8eaee;border-radius:10px;padding:.7rem .3rem;margin:0 0 1rem}' +
    '#CartDrawer .omg-trust-c{display:flex;align-items:center;justify-content:center;gap:.5rem;min-width:0;padding:0 .1rem}' +
    '#CartDrawer .omg-trust-i{width:2.4rem;height:2.4rem;border-radius:7px;background:linear-gradient(135deg,rgba(255,106,0,.14),rgba(255,140,26,.08));border:1px solid rgba(255,106,0,.25);color:#ff6a00;display:flex;align-items:center;justify-content:center;flex:none}' +
    '#CartDrawer .omg-trust-i svg{width:1.4rem;height:1.4rem;display:block}' +
    "#CartDrawer .omg-trust-c b{font-family:'Barlow Condensed','Arial Narrow',sans-serif;font-size:1.15rem;font-weight:700;letter-spacing:.03em;text-transform:uppercase;color:#101418;line-height:1.1;min-width:0}" +
    /* flatter quantity stepper on the cart card. Same selector specificity as the
       rule in omotor-cart-skin.css (1 id + 2 classes) but injected later, so this
       wins without touching that file. 106x38 -> 90x26, i.e. a wide flat pill
       instead of a chunky box. The trash button keeps its 44px tap target. */
    '#CartDrawer .quantity.cart-quantity{width:9rem !important;height:2.6rem !important;min-height:0 !important;border-radius:6px !important}' +
    '#CartDrawer .quantity.cart-quantity .quantity__button{width:2.7rem !important;min-height:0 !important;padding:0 !important}' +
    '#CartDrawer .quantity.cart-quantity .quantity__button svg{width:.85rem;height:.85rem}' +
    '#CartDrawer .quantity.cart-quantity .quantity__input{font-size:1.25rem !important;font-weight:600;min-height:0 !important}' +
    '#CartDrawer .cart-item__quantity-wrapper{gap:.6rem !important}';

  var styleEl = document.createElement('style');
  styleEl.id = 'omg-cart-fix-css';
  styleEl.textContent = css;
  (document.head || document.documentElement).appendChild(styleEl);

  /* ----------------------------------------------------------- trust strip */
  /* Paths copied verbatim from sections/omotor-trustbar.liquid so the drawer and
     the homepage draw literally the same glyphs. */
  var TRUST = [
    ['<path d="M20 12a8 8 0 1 1-2.4-5.7"/><path d="M20 3.5V8h-4.5"/>', '90-Day Returns'],
    [
      '<path d="M12 3l7 3v5.2c0 4.4-2.9 7.3-7 8.8-4.1-1.5-7-4.4-7-8.8V6l7-3z"/><path d="M9 11.8l2.1 2.1L15.3 9.7"/>',
      '1-Year Warranty',
    ],
    [
      '<path d="M1.5 6.5H14v9H1.5z"/><path d="M14 9.5h3.4l3.1 3.1v2.9H14z"/><circle cx="5.6" cy="17.6" r="1.9"/><circle cx="16.9" cy="17.6" r="1.9"/>',
      'Ships in 24h',
    ],
  ];

  function trustHTML() {
    var out = '<div class="omg-trust">';
    for (var i = 0; i < TRUST.length; i++) {
      out +=
        '<div class="omg-trust-c"><span class="omg-trust-i">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
        TRUST[i][0] +
        '</svg></span><b>' +
        TRUST[i][1] +
        '</b></div>';
    }
    return out + '</div>';
  }

  function ensureTrust() {
    var footer = document.querySelector('#CartDrawer .drawer__footer');
    if (!footer || footer.querySelector('.omg-trust')) return;
    footer.insertAdjacentHTML('afterbegin', trustHTML());
  }

  /* -------------------------------------------------------------- rendering */
  function parse(html, selector) {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function renderBubble(data) {
    var target = document.getElementById('cart-icon-bubble');
    var html = data.sections && data.sections['cart-icon-bubble'];
    if (!target || !html) return;
    var src = parse(html, '.shopify-section');
    if (src) target.innerHTML = src.innerHTML;
  }

  function renderDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', data.item_count === 0);

    var html = data.sections && data.sections['cart-drawer'];
    if (drawer && typeof drawer.renderContents === 'function' && html) {
      drawer.renderContents(data);
      ensureTrust();
      return;
    }
    var src = parse(html, '#CartDrawer');
    var dst = document.getElementById('CartDrawer');
    if (src && dst) dst.innerHTML = src.innerHTML;
    renderBubble(data);
    ensureTrust();
  }

  function renderPage(data) {
    [
      ['main-cart-items', '.js-contents'],
      ['main-cart-footer', '.js-contents'],
    ].forEach(function (pair) {
      var host = document.getElementById(pair[0]);
      if (!host) return;
      host.classList.toggle('is-empty', data.item_count === 0);
      var key = host.dataset && host.dataset.id;
      var html = key && data.sections && data.sections[key];
      var src = parse(html, pair[1]);
      var dst = host.querySelector(pair[1]);
      if (src && dst) dst.innerHTML = src.innerHTML;
    });
    renderBubble(data);
  }

  function pageSections() {
    var out = [];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.dataset && el.dataset.id) out.push(el.dataset.id);
    });
    out.push('cart-icon-bubble');
    return out;
  }

  /* ----------------------------------------------------------------- remove */
  function legacyRemove(btn, line) {
    var host = btn.closest('cart-drawer-items') || btn.closest('cart-items');
    if (host && typeof host.updateQuantity === 'function') {
      try {
        host.updateQuantity(line, 0);
        return;
      } catch (err) {
        console.error('[omotor-cart-fix] theme updateQuantity failed', err);
      }
    }
    window.location.href = CART_URL;
  }

  function removeLine(btn) {
    var line = btn.getAttribute('data-index');
    if (!line) {
      legacyRemove(btn, btn.dataset ? btn.dataset.index : null);
      return;
    }
    var inDrawer = !!btn.closest('cart-drawer-items');
    var row = btn.closest('.cart-item');
    var spinner = row ? row.querySelector('.loading__spinner') : null;
    if (row) row.classList.add('omg-removing');
    if (spinner) spinner.classList.remove('hidden');

    fetch(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: parseInt(line, 10),
        quantity: 0,
        sections: inDrawer ? ['cart-drawer', 'cart-icon-bubble'] : pageSections(),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (!data || data.status) {
          throw new Error((data && (data.description || data.message)) || 'cart change rejected');
        }
        if (inDrawer) renderDrawer(data);
        else renderPage(data);
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'omotor-cart-fix', cartData: data });
          }
        } catch (err) {
          /* pub/sub is optional */
        }
        schedule();
      })
      .catch(function (err) {
        console.error('[omotor-cart-fix] remove failed, falling back', err);
        if (row) row.classList.remove('omg-removing');
        if (spinner) spinner.classList.add('hidden');
        legacyRemove(btn, line);
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var btn = target.closest('cart-remove-button');
      if (!btn) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (btn.getAttribute('data-omg-busy')) return;
      btn.setAttribute('data-omg-busy', '1');
      setTimeout(function () {
        btn.removeAttribute('data-omg-busy');
      }, 1500);

      removeLine(btn);
    },
    true
  );

  /* -------------------------------------------------------- scroll indicator */
  var track = null;
  var thumb = null;
  var pending = false;

  function ensureTrack() {
    if (track && track.isConnected) return track;
    track = document.createElement('div');
    track.className = 'omg-sb';
    thumb = document.createElement('div');
    thumb.className = 'omg-sb-thumb';
    track.appendChild(thumb);
    (document.body || document.documentElement).appendChild(track);
    return track;
  }

  function off() {
    if (track) track.classList.remove('is-on');
  }

  function update() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return off();

    var box = document.querySelector('#CartDrawer cart-drawer-items');
    if (!box) return off();

    var scrollHeight = box.scrollHeight;
    var clientHeight = box.clientHeight;
    if (scrollHeight - clientHeight < 8 || clientHeight < 40) return off();

    ensureTrack();
    var rect = box.getBoundingClientRect();
    var pad = 6;
    var railHeight = rect.height - pad * 2;
    if (railHeight <= 20) return off();

    var thumbHeight = Math.max(32, (clientHeight / scrollHeight) * railHeight);
    var travel = railHeight - thumbHeight;
    var ratio = box.scrollTop / (scrollHeight - clientHeight);
    if (ratio < 0) ratio = 0;
    if (ratio > 1) ratio = 1;

    track.style.top = rect.top + pad + 'px';
    track.style.left = rect.right - 9 + 'px';
    track.style.height = railHeight + 'px';
    thumb.style.height = thumbHeight + 'px';
    thumb.style.transform = 'translateY(' + travel * ratio + 'px)';
    track.classList.add('is-on');
  }

  function schedule() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      pending = false;
      ensureTrust();
      update();
    });
  }

  document.addEventListener('scroll', schedule, true);
  document.addEventListener('touchmove', schedule, true);
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  setInterval(schedule, 250);

  /* the drawer is re-rendered wholesale on every cart change — put the strip
     straight back instead of waiting for the next tick */
  function watch() {
    var host = document.getElementById('CartDrawer');
    if (!host || !window.MutationObserver) return;
    new MutationObserver(function () {
      ensureTrust();
    }).observe(host, { childList: true, subtree: true });
  }

  function boot() {
    ensureTrust();
    watch();
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
